var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5013 16.8334C13.1037 16.8334 16.8346 13.1025 16.8346 8.50008C16.8346 3.89771 13.1037 0.166748 8.5013 0.166748C3.89893 0.166748 0.167969 3.89771 0.167969 8.50008C0.167969 13.1025 3.89893 16.8334 8.5013 16.8334Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5.29541C13.1324 5.45875 12.7367 5.56875 12.3217 5.61841C12.7454 5.36441 13.0707 4.96245 13.2237 4.4835C12.8277 4.71879 12.3881 4.88912 11.9211 4.98145C11.5468 4.58283 11.0132 4.3335 10.4235 4.3335C9.29063 4.3335 8.372 5.25212 8.372 6.38504C8.372 6.54566 8.39033 6.70233 8.42533 6.85266C6.72013 6.76733 5.20854 5.95037 4.19662 4.70912C4.01996 5.01212 3.91896 5.36441 3.91896 5.74041C3.91896 6.45204 4.28062 7.08 4.83158 7.44795C4.49492 7.43729 4.17896 7.34495 3.90196 7.19129V7.21695C3.90196 8.21125 4.60958 9.04016 5.54754 9.22916C5.37554 9.27583 5.19421 9.30116 5.00725 9.30116C4.87492 9.30116 4.74625 9.28816 4.62092 9.26416C4.88192 10.0791 5.63987 10.6724 6.53746 10.6891C5.8355 11.239 4.95092 11.5673 3.98963 11.5673C3.82363 11.5673 3.66033 11.5577 3.5 11.5383C4.40796 12.1203 5.48621 12.4603 6.64479 12.4603C10.4182 12.4603 12.4817 9.33416 12.4817 6.62333C12.4817 6.53433 12.4801 6.4457 12.4757 6.35804C12.877 6.06804 13.225 5.70675 13.5 5.29541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterPublic);
export default __webpack_public_path__ + "static/media/twitterPublic.1470677a972e93aa2864c88f17c7548d.svg";
export { ForwardRef as ReactComponent };